export const DEFAULT_CALL_ANSWER_TIMEOUT_SEC = 30;
export const DEFAULT_HANDOFF_ANSWER_TIMEOUT_SEC = 30;
export const DEFAULT_SESSION_UPDATE_TIMER_SEC = 30;
export const DEFAULT_INTERPRETING_TIMER_SEC = 30;
export const DEFAULT_SERVICE_UNREGISTERED_HEARING_TO_DEAF_CALLS = false;
